/** @format */

import React, { Fragment, useEffect, useState, useRef } from "react";
import TableForm from "./tableForm";
import ReactToPrint from "react-to-print";
import { useReactToPrint } from "react-to-print";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";
import ReactDOM from "react-dom/client";

import { Document, Page, pdfjs } from "react-pdf";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";
import logo from "./logo/udes.png";
import { tr } from "date-fns/locale";
import { set } from "date-fns";

export const Apprenticeship_req_asigned = ({ setAuth }) => {
  const [reqUpdateData, setReqUpdateData] = useState({
    intern_req_asigned_str: "",
    intern_id: "",
  });

  const [name, setName] = useState("");
  const [empId, setEmpId] = useState(null);
  const [priv, setPriv] = useState("");
  const [empRole, setEmpRole] = useState("");
  const [userStr, setUserStr] = useState("");

  async function getName() {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parsRes = await resp.json();
      // console.log(parsRes);

      setName(parsRes.emp_name);
      setPriv(parsRes.emp_level);
      setEmpId(parsRes.emp_id);
      setEmpRole(parsRes.emp_role);
      setUserStr(parsRes.asigned_str);
    } catch (err) {
      console.error(err.message);
    }
  }

  const [structures, setStructures] = useState([]);

  async function getStructures() {
    try {
      const getStr = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/structures`
      );
      const parsRes = await getStr.json();
      setStructures(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }

  // get all apprenticeship requests -------------------

  const [apprenticeshipRequests, setApprenticeshipRequests] = useState([]);
  const [attachedFilesPaths, setAttachedFilesPaths] = useState([]);
  const [attachedProfilePicPaths, setAttachedProfilePicPaths] = useState([]);

  async function getApprenticeshipRequests() {
    try {
      if (empId !== null && empId !== undefined) {
        const resp = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/apprenticeshipRequestsForUser/${empId}`,
          {
            method: "GET",
            headers: { token: localStorage.token },
          }
        );
        const parsRes = await resp.json();
        // console.log(parsRes);
        setApprenticeshipRequests(parsRes.requestData);
        setAttachedFilesPaths(parsRes.filePaths);
        setAttachedProfilePicPaths(parsRes.picPaths);
      }
    } catch (err) {
      console.error(err.message);
    }
  }

  const [selectedReqDocs, setSelectedReqDocs] = useState([]);
  const getSelectedReqDocs = (docsList, reqId) => {
    let element = [];
    if (reqId !== null && reqId !== undefined) {
      element = docsList.filter((doc) =>
        doc.split("-")[0].endsWith(reqId.toString())
      );
    }

    setSelectedReqDocs(element);
  };

  const [selectedReqProfilePic, setSelectedReqProfilePic] = useState([]);
  const getSelectedReqProfilePic = (docsList, reqId) => {
    setSelectedReqProfilePic([]);
    let element = [];
    if (reqId !== null && reqId !== undefined) {
      element = docsList.filter((doc) =>
        doc.split("-")[0].endsWith(reqId.toString())
      );
    }

    setSelectedReqProfilePic(element);
  };

  //----------------------------------------------------

  // get the list of users under the current structure -----------------------
  const [strUsers, setStrUsers] = useState([]);
  async function getCurrentStrUsers() {
    try {
      const url = `api/getCurrentStrUsers/${userStr}`;

      const currentStrUsers = await fetch(url, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.token,
        },
      });
      const response = await currentStrUsers.json();

      setStrUsers(response);
    } catch (err) {
      console.error(err.message);
    }
  }
  //-------------------------------------------------------------------------

  // update the status of the request ----------------------------------

  async function updateInternShipReqStatus() {
    try {
      const reqStatusUpdate = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/updateInternShipReqStatus`,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            token: localStorage.token,
          },
          body: JSON.stringify(reqUpdateData),
        }
      );

      if (reqStatusUpdate.ok) {
        accept();
        document.getElementById("printing-menu-btn").disabled = true;
        getApprenticeshipRequests();
      }
    } catch (err) {
      console.error(err.message);
    }
  }

  // --------------------------------------------------------------------

  const [selectedReqID, setSelectedReqID] = useState(null);

  const handleRequestSelect = (reqID) => {
    setSelectedReqID(reqID);
  };

  const [selectedForm, setSelectedForm] = useState([]);
  const getReqToDisplay = (selectedId) => {
    for (let i = 0; i < apprenticeshipRequests.length; i++) {
      if (apprenticeshipRequests[i].intern_id === selectedId) {
        setSelectedForm(apprenticeshipRequests[i]);
      }
    }
  };

  const getStrName = (strId) => {
    for (let i = 0; i < structures.length; i++) {
      if (strId === null) {
        return "None affecté";
      } else if (structures[i].str_id === strId) {
        return structures[i].str_name;
      }
    }
  };

  useEffect(() => {
    getReqToDisplay(selectedReqID);
    getSelectedReqDocs(attachedFilesPaths, selectedReqID);
    getSelectedReqProfilePic(attachedProfilePicPaths, selectedReqID);
    document.getElementById("printing-menu-btn").disabled = false;
  }, [selectedReqID]);

  useEffect(() => {
    getStructures();
    getApprenticeshipRequests();
    document.getElementById("printing-menu-btn").disabled = true;
  }, []);

  useEffect(() => {
    if (empId !== null) {
      getApprenticeshipRequests();
    }
  }, [empId]);

  const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    setAuth(false);
    toast.current.show({
      severity: "success",
      summary: "Session",
      detail: "Deconnecté",
    });
  };

  useEffect(() => {
    getName();
  }, []);

  useEffect(() => {
    if (userStr !== "") {
      getCurrentStrUsers();
    }
  }, [userStr]);

  const toast = useRef(null);

  const accept = () => {
    toast.current.show({
      severity: "success",
      summary: "conifrmé",
      detail: "demande affectée",
      life: 3000,
    });
  };
  const accept2 = () => {
    toast.current.show({
      severity: "success",
      summary: "conifrmé",
      detail: "Encadrant affectée",
      life: 3000,
    });
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulée",
      detail: "Operation annulée",
      life: 3000,
    });
  };

  const confirm2 = (aptSpv) => {
    confirmDialog({
      message: "Confirmer l'affectation de l'encadrant?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => updateSpv(aptSpv),
      reject,
    });
  };

  // print the document -------------------------------------------------

  // Create a refs array
  const componentRefs = useRef([]);

  // Create a ref for each element in selectedReqDocs
  selectedReqDocs.forEach((_, i) => {
    if (!componentRefs.current[i]) {
      componentRefs.current[i] = React.createRef();
    }
  });

  const componentRef = React.useRef(null);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const componentRef2 = React.useRef(null);

  const reactToPrintContent2 = React.useCallback(() => {
    return componentRef2.current;
  }, [componentRef2.current]);

  const reactToPrintTrigger = React.useCallback(() => {
    return (
      <button
        className="bg-custom_blue1 hover:bg-blue-700"
        id="printing-menu-btn"
      >
        Imprimer
      </button>
    );
  }, []);

  const iframeRef = React.useRef(null);

  const printDocument = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.print();
    }
  };

  //---------------------------------------------------------------------------------

  const [selectedDocToView, setSelectedDocToview] = useState(null);

  const handleListItemClick = (doc) => {
    setSelectedDocToview(doc);
  };

  let reactToPrintTrigger2 = null;

  function printIframe(id) {
    var iframe = document.getElementById(id);
    var contentWindow = iframe.contentWindow;
    contentWindow.print();
  }
  const [selectedSpv, setSelectedSpv] = useState("");
  // const setPrivilege = async () => {
  //   // set privilege
  //   const response = await fetch(
  //     `${process.env.REACT_APP_BACKEND_URL}/api/privilegeSet`,
  //     {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         token: localStorage.token,
  //       },
  //       body: JSON.stringify(privData),
  //     }
  //   );
  //   if (response.ok) {
  //     accept();
  //   }
  // };

  const pageRerender = () => {
    const container = document.getElementById("req_mentor");
    const root = ReactDOM.createRoot(container);
    root.render(
      <span id="req_mentor" className="value">
        {displaySpvName(selectedForm.spv_id)}
      </span>
    );
  };

  const setAptSpv = async (e) => {
    const aptSpv = [e.target.value];
    confirm2(aptSpv);
  };

  const updateSpv = async (aptSpv) => {
    const intern_id = selectedForm.intern_id;
    const setAptSpv = await fetch(`/api/setAptSpv/${intern_id}`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: localStorage.token,
      },

      body: JSON.stringify(aptSpv),
    });
    if (setAptSpv.ok) {
      getApprenticeshipRequests();
      handleRequestSelect(intern_id);
      pageRerender();
      accept2();
    }
  };

  const displaySpvName = (spvId) => {
    let spvName = "";
    for (let i = 0; i < strUsers.length; i++) {
      if (strUsers[i].emp_id == spvId) {
        spvName = strUsers[i].emp_name;
      }
    }
    return spvName;
  };

  return (
    <Fragment>
      <div id="navbar" className="topnav">
        <div className="left-menu-4">
          <Link to="/dashboard">Accueil</Link>
        </div>
        <div className="right-menu">
          <button className="dash-logout" onClick={(e) => logout(e)}>
            Se déconnecter
          </button>

          <div className=" relative flex items-center justify-center float-right pr-3">
            <span className="p-3 text-white">{name}</span>
          </div>
        </div>
      </div>

      <div className="training-req-container">
        <div className="req_treatment_container-fluid">
          <div className="req_treatment_list">
            <table className="table-list">
              <thead className="table-header">
                <tr>
                  <th>Nom du demandeur</th>

                  <th>Date de la demande</th>
                  <th>Affectation</th>
                </tr>
              </thead>
              <tbody>
                {apprenticeshipRequests.map((request) => (
                  <tr
                    onClick={(e) => handleRequestSelect(request.intern_id)}
                    className="table-row"
                    key={request.req_id}
                    style={{
                      backgroundColor:
                        getStrName(request.intern_req_asigned_str) ===
                          "None affecté"
                          ? "white"
                          : "lightgreen",
                    }}
                  >
                    <td>{request.intern_name}</td>
                    <td>
                      {new Date(request.intern_req_date).toLocaleDateString(
                        "en-GB"
                      )}
                      <br />
                      {new Date(request.intern_req_date).toLocaleTimeString(
                        "en-GB"
                      )}
                    </td>

                    <td>{getStrName(request.intern_req_asigned_str)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="req-tr-document">
            <div ref={componentRef} className="document-page">
              <div className="doc-heading">
                <div className="doc-heading-top">
                  <div className="doc-ht-ar">
                    الجمهورية الجزائرية الديمقراطية الشعبية
                  </div>
                  <div className="doc-ht-fr">
                    République Algérienne Démocratique et Populaire
                  </div>
                  <div className="doc-ht-ar">
                    وزارة التعليم العالي و البحث العلمي
                  </div>
                  <div className="doc-ht-fr">
                    Ministère de l'Enseignement Supérieur et de la Recherche
                    Scientifique
                  </div>
                </div>
                <div className="doc-heading-line"></div>
                <div className="doc-heading-bottom">
                  <div className="doc-hb-left">
                    <span className="doc-hb-uplef-text">EPST/CDER</span>
                    <span className="doc-hb-bottlef-text">
                      UNITE DE DEVELOPEMENT DES EQUIPEMENTS SOLAIRES
                    </span>
                  </div>
                  <div className="doc-heading-logo">
                    <img src={logo} alt="logo" />
                  </div>

                  <div className="doc-hb-right">
                    <span className="doc-hb-upright-text">
                      م.ع.ط.ع.ت./م.ط.ت.م
                    </span>
                    <span className="doc-hb-bottright-text">
                      وحدة تنمية الاجهزة الشمسية
                    </span>
                  </div>
                </div>
                <div className="doc-heading-line"></div>
              </div>

              <div className="doc-body-top">
                <div className="doc-top-info">
                  <span className="label">N°:</span>
                  <span className="value">{selectedForm.intern_req_ref}</span>
                </div>
                <div className="doc-top-info">
                  <span className="label">Date:</span>
                  <span className="value">
                    {new Date(selectedForm.intern_req_date).toLocaleDateString(
                      "en-GB"
                    )}
                  </span>
                </div>
              </div>

              <div className=" flex justify-end">
                {selectedReqProfilePic.length > 0 ? (
                  <img
                    src={selectedReqProfilePic}
                    style={{ width: "128px", height: "128px" }}
                    alt={selectedReqProfilePic}
                  ></img>
                ) : (
                  <img
                    src={require("./images/profile_pic_place_holder.jpg")}
                    style={{ width: "128px", height: "128px" }}
                  ></img>
                )}
              </div>

              <div className="info">
                <span className="" htmlFor="req_name">
                  Nom et prénom:
                </span>
                <span id="req_name" className="value" value="value">
                  {selectedForm.intern_name}
                </span>
              </div>
              <div className="info">
                <span className="" htmlFor="req_birthday">
                  Date de naissance:
                </span>
                <span id="req_birthay" className="value">
                  {selectedForm.intern_birthday}
                </span>
              </div>
              <div className="info">
                <span className="" htmlFor="req_place_of_birth">
                  Lieu de naissance:
                </span>
                <span id="req_place_of_birth" className="value">
                  {selectedForm.intern_place_of_birth}
                </span>
              </div>
              <div className="info">
                <span for="email" className="" htmlFor="intern_email">
                  Email:
                </span>
                <span id="intern_email" className="value">
                  {selectedForm.intern_email}
                </span>
              </div>
              <div className="info">
                <span className="" htmlFor="req_school">
                  Université:
                </span>
                <span id="req_school" className="value">
                  {selectedForm.intern_grad_school}
                </span>
              </div>
              <div className="info">
                <span className="" htmlFor="req_school_level">
                  Niveau d'instruction:
                </span>
                <span id="req_school_level" className="value">
                  {selectedForm.intern_ed_level}
                </span>
              </div>
              <div className="info">
                <span className="" htmlFor="req_speciality">
                  Spécialité:
                </span>
                <span id="req_speciality" className="value">
                  {selectedForm.intern_study_field}
                </span>
              </div>

              <div className="info">
                <span className="" htmlFor="req_type">
                  Type de stage:
                </span>
                <span id="req_type" className="value">
                  {selectedForm.intern_req_type}
                </span>
              </div>
              <div className="info">
                <span className="" htmlFor="req_mentor">
                  Encadrant au niveau de l'unité
                </span>
                <span id="req_mentor" className="value">
                  {displaySpvName(selectedForm.spv_id)}
                </span>
              </div>
              <div className="doc-body-bottom">
                <div id="doc-approvers" className="doc-approvers"></div>
              </div>

              <div className="doc-footer">
                <div className="doc-footer-separator"></div>
                <span className="doc-footer-text">
                  UDES, Route Nationale N°11, BP386, Bou-Ismail, 42415, Wilaya
                  de Tipaza Tel. / Fax : 024221408, Site Web :udes.cder.dz
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="navBarControls_req_treatment">
          <div className="printing-menu">
            <span>Imprimer le document</span>
            <ReactToPrint
              content={reactToPrintContent}
              documentTitle="AwesomeFileName"
              removeAfterPrint
              trigger={reactToPrintTrigger}
            />
          </div>

          <div className="printing-menu">
            <span>Désigner un encadrant</span>
            <select
              id="spvSelect"
              className="text-black bg-gray-100"
              onChange={(e) => {
                setAptSpv(e);
              }}
            >
              <option
                className="text-black"
                defaultValue={""}
                selected
                disabled
              >
                --selectionnez un encadrant--
              </option>
              {strUsers.map((user) => (
                <option key={user.emp_id} value={user.emp_id}>
                  {user.emp_name}
                </option>
              ))}
            </select>
          </div>

          <div className="aprenticeship-req-linked-files">
            <h6>Documents en pièces jointes</h6>
            {selectedReqDocs.map((f, i, id) => (
              <li
                style={{ listStyleType: "none" }}
                className="apShip-req-fileItem-list"
              >
                {f.endsWith(".jpeg") ||
                  f.endsWith(".jpg") ||
                  f.endsWith(".png") ||
                  f.endsWith(".svg") ? (
                  // Image file
                  <a
                    href={`${process.env.REACT_APP_BACKEND_URL}` + f}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      id={id}
                      style={{ maxWidth: "200px", maxHeight: "auto" }}
                      src={`${process.env.REACT_APP_BACKEND_URL}` + f}
                      alt={f}
                    />
                  </a>
                ) : f.endsWith(".pdf") ? (
                  <a
                    href={`${process.env.REACT_APP_BACKEND_URL}` + f}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <iframe
                      id="iframe"
                      style={{ maxWidth: "200px", maxHeight: "auto" }}
                      src={`${process.env.REACT_APP_BACKEND_URL}` + f}
                    ></iframe>
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                    ></div>
                  </a>
                ) : (
                  // Other file type
                  <div>Unsupported file type</div>
                )}
              </li>
            ))}
          </div>
        </div>

        <Toast ref={toast} />

        <div className="p-confirm-dialog	">
          <ConfirmDialog className="p-confirm-dialog" />
        </div>
      </div>
    </Fragment>
  );
};
